"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mood = exports.moodOrder = exports.MoodName = void 0;
const react_1 = __importDefault(require("react"));
const BadMood_1 = require("./moods/BadMood");
const GoodMood_1 = require("./moods/GoodMood");
const GreatMood_1 = require("./moods/GreatMood");
const MehMood_1 = require("./moods/MehMood");
const OkayMood_1 = require("./moods/OkayMood");
const TerribleMood_1 = require("./moods/TerribleMood");
var MoodName;
(function (MoodName) {
    MoodName["GREAT"] = "GREAT";
    MoodName["GOOD"] = "GOOD";
    MoodName["OKAY"] = "OKAY";
    MoodName["MEH"] = "MEH";
    MoodName["BAD"] = "BAD";
    MoodName["TERRIBLE"] = "TERRIBLE";
})(MoodName = exports.MoodName || (exports.MoodName = {}));
exports.moodOrder = [MoodName.GREAT, MoodName.GOOD, MoodName.OKAY, MoodName.MEH, MoodName.BAD, MoodName.TERRIBLE];
exports.Mood = (_a) => {
    var { name } = _a, rest = __rest(_a, ["name"]);
    switch (name) {
        case MoodName.BAD:
            return react_1.default.createElement(BadMood_1.BadMood, Object.assign({}, rest));
        case MoodName.GOOD:
            return react_1.default.createElement(GoodMood_1.GoodMood, Object.assign({}, rest));
        case MoodName.GREAT:
            return react_1.default.createElement(GreatMood_1.GreatMood, Object.assign({}, rest));
        case MoodName.MEH:
            return react_1.default.createElement(MehMood_1.MehMood, Object.assign({}, rest));
        case MoodName.OKAY:
            return react_1.default.createElement(OkayMood_1.OkayMood, Object.assign({}, rest));
        case MoodName.TERRIBLE:
            return react_1.default.createElement(TerribleMood_1.TerribleMood, Object.assign({}, rest));
        default:
            return null;
    }
};
//# sourceMappingURL=Mood.js.map